import { MEETINGS_MEASURES } from 'cube/constants'

import type { CubeQuery } from '@driftt/dds.reports'

export const MeetingCountQuery: CubeQuery = {
  name: 'DriftChatSchedulingEvents',
  query: {
    measures: [MEETINGS_MEASURES.MEETING_COUNT],
    order: {
      [MEETINGS_MEASURES.MEETING_COUNT]: 'desc',
    },
  },
  queryName: 'DriftChatSchedulingEvents',
}
